import { FORM_FIELDS, FORM_FIELDS_NAMES } from '../new-application/new-application-form';
import { ILists } from '../../interfaces/merchant';
import { IFormInputProps } from '../../components/merchants/FormInput';
import { InputType } from '../../components/form/form-input-constants';

interface IVolumeEstimatesInputs {
  t: any;
  lists: ILists;
  isRequired: boolean;
}
export const SELF_ONBOARDING_VOLUME_ESTIMATES_INPUTS = ({ t, lists, isRequired }: IVolumeEstimatesInputs): IFormInputProps[] => [
  {
    key: FORM_FIELDS.MONTHLY_VOLUME,
    fieldName: FORM_FIELDS.MONTHLY_VOLUME,
    placeholder: t(FORM_FIELDS_NAMES.MONTHLY_VOLUME_PLACEHOLDER),
    label: t(FORM_FIELDS_NAMES.MONTHLY_VOLUME),
    inputType: InputType.Select,
    data: lists.averageSales,
    searchable: false,
    cleanable: false,
    required: isRequired,
    autoComplete: 'off'
  },
  {
    key: FORM_FIELDS.MONTHLY_DECLINES,
    fieldName: FORM_FIELDS.MONTHLY_DECLINES,
    placeholder: t(FORM_FIELDS_NAMES.MONTHLY_DECLINES_PLACEHOLDER),
    label: t(FORM_FIELDS_NAMES.MONTHLY_DECLINES),
    inputType: InputType.Select,
    data: lists.averageDeclineRate,
    searchable: false,
    cleanable: false,
    required: isRequired,
    autoComplete: 'off'
  },
  {
    key: FORM_FIELDS.MONTHLY_TRANSACTIONS,
    fieldName: FORM_FIELDS.MONTHLY_TRANSACTIONS,
    placeholder: t(FORM_FIELDS_NAMES.MONTHLY_TRANSACTIONS),
    label: t(FORM_FIELDS_NAMES.MONTHLY_TRANSACTIONS),
    inputType: InputType.Select,
    data: lists.averageTransactionAmount,
    searchable: false,
    cleanable: false,
    required: isRequired,
    autoComplete: 'off'
  },
  {
    key: FORM_FIELDS.RETURN_RATE,
    fieldName: FORM_FIELDS.RETURN_RATE,
    placeholder: t(FORM_FIELDS_NAMES.RETURN_RATE),
    label: t(FORM_FIELDS_NAMES.RETURN_RATE),
    inputType: InputType.Select,
    data: lists.averageReturnRate,
    searchable: false,
    cleanable: false,
    required: isRequired,
    autoComplete: 'off'
  },
  {
    key: FORM_FIELDS.CHARGEBACK_RATE,
    fieldName: FORM_FIELDS.CHARGEBACK_RATE,
    placeholder: t(FORM_FIELDS_NAMES.CHARGEBACK_RATE_PLACEHOLDER),
    label: t(FORM_FIELDS_NAMES.CHARGEBACK_RATE),
    inputType: InputType.Select,
    data: lists.averageChargebackRate,
    searchable: false,
    cleanable: false,
    required: isRequired,
    // isLabelIcon: true,
    // tooltipText: FORM_FIELDS_NAMES.IS_RELATED_TO_HEALTH_TOOLTIP,
    autoComplete: 'off'
  },
  // {
  //   key: FORM_FIELDS.DECLINE_RATE,
  //   fieldName: FORM_FIELDS.DECLINE_RATE,
  //   placeholder: t(FORM_FIELDS_NAMES.DECLINE_RATE_PLACEHOLDER),
  //   label: t(FORM_FIELDS_NAMES.DECLINE_RATE),
  //   inputType: InputType.Select,
  //   data: lists.averageDisputeRate,
  //   searchable: false,
  //   cleanable: false,
  //   required: isRequired,
  //   // isLabelIcon: true,
  //   // tooltipText: FORM_FIELDS_NAMES.IS_RELATED_TO_HEALTH_TOOLTIP,
  //   autoComplete: 'off'
  // },
];
